// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const filterByReference = (tableRow, nestedRowsId, isIncluded = true) => tableRow.filter((el) => isIncluded
    ? nestedRowsId.find((element) => element === el.id)
    : !nestedRowsId.find((element) => element === el.id));
//# sourceMappingURL=filterByReference.js.map